/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import React from 'react';
import { withNamespaces } from 'react-i18next';
import createButtonCss from '../../../ui/Button/Button';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { SOLUTION_BUILDER as dict } from '../../../../utils/dictionarykeys';
import SidePanelEnquiryForm from '../SidePanelEnquiryForm';
import * as styles from './index.styles.js';
import SidePanel from '../../SolutionBuilder/SidePanel';

class SidePanelEnquiryButton extends SafePureComponent {
  state = {
    isSidePanelOpen: false,
  };

  openSidePanelHandler = () => {
    this.setState({ isSidePanelOpen: true });
  };

  closeSidePanelHandler = () => {
    this.setState({ isSidePanelOpen: false });
  };

  renderForm = () => {
    return <SidePanelEnquiryForm location={this.props.location} />;
  };

  safeRender() {
    return (
      <React.Fragment>
        <SidePanel
          body={this.renderForm}
          customStyles={styles.panel}
          isSidePanelOpen={this.state.isSidePanelOpen}
          onRequestClose={this.closeSidePanelHandler}
          toggleSidePanel={this.closeSidePanelHandler}
        />
        <div css={styles.buttonWrapper}>
          <button css={createButtonCss()} onClick={this.openSidePanelHandler}>
            {this.props.t(dict.DISCUSS_QUOTE_CTA)}
          </button>
        </div>
      </React.Fragment>
    );
  }
}

SidePanelEnquiryButton.displayName = 'SolutionBuilderResults/SidePanelEnquiryButton';

SidePanelEnquiryButton.defaultProps = {
  t: key => key,
  location: {},
};

SidePanelEnquiryButton.propTypes = {
  t: PropTypes.func,
  location: PropTypes.object,
};

export default withNamespaces()(SidePanelEnquiryButton);
